import React from 'react';
import { Navigation } from '../components/Navigation';
const HENNA_IMAGES = ['https://cdn.magicpatterns.com/uploads/c5k3CinmKtq6s19ZM6CB9V/1370708135.jpg', 'https://cdn.magicpatterns.com/uploads/cNE7YuqTHuMf4TsombCFXE/2062777613.jpg', 'https://cdn.magicpatterns.com/uploads/fNsgQUnZKodoyd1SB3yo9G/2192241251.jpg', 'https://cdn.magicpatterns.com/uploads/rJciUcL3VRGM2jE5yyf5BX/2281250931.jpg', 'https://cdn.magicpatterns.com/uploads/6qtK6yV1bdKmygyVint7FT/2356656893.jpg', 'https://cdn.magicpatterns.com/uploads/a4a6XQrfv4uWF5WPyh523j/2365804537.jpg', 'https://cdn.magicpatterns.com/uploads/4Dpw6PoEqJUVtGXUW4xm42/2432804589.jpg', 'https://cdn.magicpatterns.com/uploads/idjQCoyR6iFBBcBwccEkJN/2488853691.jpg', 'https://cdn.magicpatterns.com/uploads/8ctcTX3gG4rTDK8mhSrD6g/2628220205.jpg', 'https://cdn.magicpatterns.com/uploads/icSY8bxVCmxkrxwAnVfjRp/2720377531.jpg'];
const GeometricPattern = () => <svg viewBox="0 0 100 100" className="w-full h-full opacity-10" data-id="element-62">
    <path d="M 50 0 L 100 50 L 50 100 L 0 50 Z" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-63" />
    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-64" />
  </svg>;
export function HennaPage() {
  return <div className="min-h-screen bg-[#d9e2e8] p-2 md:p-4 font-sans selection:bg-accent selection:text-white" data-id="element-65">
      <div className="main-container max-w-[1600px] mx-auto bg-card rounded-[1.5rem] md:rounded-[2rem] border-2 border-[#ef3e23] shadow-sm min-h-[calc(100vh-2rem)] flex flex-col" data-id="element-66">
        <Navigation activePath="/henna" data-id="element-67" />
        <main className="flex-1 px-4 md:px-16 py-8 space-y-16 md:space-y-32" data-id="element-68">
          {/* Hero Section */}
          <section className="relative flex flex-col justify-between pt-4 md:pt-8 pb-8 md:pb-12" data-id="element-69">
            <div className="max-w-6xl" data-id="element-70">
              <h1 className="text-[clamp(2.5rem,8vw,8rem)] font-semibold leading-[0.95] md:leading-[0.9] tracking-[-0.04em] text-ink" data-id="element-71">
                Henna <br data-id="element-72" />
                Inspiration
                <span className="text-accent inline-block w-[0.15em] h-[0.15em] rounded-full ml-[0.05em] mb-[0.1em]" data-id="element-73" />
              </h1>
              <div className="mt-6 max-w-sm text-base md:text-lg leading-[1.6] md:leading-[1.7] text-ink font-medium" data-id="element-74">
                Traditional patterns and contemporary applications. Exploring
                the intricate geometry of Henna art.
              </div>
            </div>
          </section>

          {/* Main Gallery */}
          <section className="space-y-8 md:space-y-12" data-id="element-75">
            <div className="bg-white rounded-[1rem] md:rounded-[1.5rem] p-6 md:p-12 border border-black/5 space-y-10" data-id="element-76">
              <div className="flex items-center gap-3" data-id="element-77">
                <div className="w-2 md:w-2.5 h-2 md:h-2.5 rounded-full bg-accent" data-id="element-78" />
                <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-muted-foreground" data-id="element-79">
                  Pattern Library
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-80">
                {HENNA_IMAGES.map((src, i) => <div key={i} className="group relative aspect-square rounded-2xl overflow-hidden border border-black/5 bg-white shadow-sm hover:shadow-md transition-all" data-id="element-81">
                    <img src={src} alt={`Henna Pattern ${i + 1}`} className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-82" />
                    <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider border border-black/5" data-id="element-83">
                      Pattern 0{i + 1}
                    </div>
                  </div>)}
              </div>
            </div>
          </section>

          {/* Meaning & Tradition Section */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-84">
            <div className="bg-white rounded-[1.5rem] p-8 md:p-16 border border-black/5 flex flex-col justify-center space-y-8" data-id="element-85">
              <div className="space-y-4" data-id="element-86">
                <h3 className="text-3xl md:text-5xl font-semibold tracking-tight text-ink" data-id="element-87">
                  The Tradition
                </h3>
                <p className="text-ink/60 text-lg leading-relaxed" data-id="element-88">
                  Henna represents joy, beauty, and spiritual awakening. Each
                  stroke and curve tells a story of heritage and celebration.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-89">
                <div className="p-4 rounded-xl bg-[#d9e2e8]/30 border border-black/5" data-id="element-90">
                  <span className="block text-[10px] font-bold uppercase text-accent mb-1" data-id="element-91">
                    Style
                  </span>
                  <span className="text-sm font-bold text-ink" data-id="element-92">
                    Traditional Mandalas
                  </span>
                </div>
                <div className="p-4 rounded-xl bg-[#d9e2e8]/30 border border-black/5" data-id="element-93">
                  <span className="block text-[10px] font-bold uppercase text-accent mb-1" data-id="element-94">
                    Focus
                  </span>
                  <span className="text-sm font-bold text-ink" data-id="element-95">
                    Intricate Borders
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-[#2b2b2b] text-white rounded-[1.5rem] p-8 md:p-16 relative overflow-hidden" data-id="element-96">
              <div className="absolute top-0 right-0 w-48 h-48 opacity-20 -mr-12 -mt-12" data-id="element-97">
                <GeometricPattern data-id="element-98" />
              </div>
              <div className="relative z-10 space-y-6" data-id="element-99">
                <h3 className="text-3xl md:text-5xl font-semibold tracking-tight" data-id="element-100">
                  Modern Application
                </h3>
                <p className="text-white/60 text-lg leading-relaxed" data-id="element-101">
                  Bridging the gap between ancient ritual and modern aesthetic.
                  These patterns are designed to be both timeless and
                  contemporary.
                </p>
                <div className="pt-6 flex flex-wrap gap-3" data-id="element-102">
                  {['Intricate', 'Floral', 'Geometric', 'Symmetrical'].map(tag => <span key={tag} className="px-4 py-2 rounded-full border border-white/20 text-xs font-bold uppercase tracking-widest" data-id="element-103">
                        {tag}
                      </span>)}
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>;
}